// The property strategy tool, /property-strategy (docs/property-strategy-spec.md): Adam's free tool, public and logged
// out alike, ahead of the login door, as /register is (App.jsx). Staging only until Adam switches it on
// (strategy/route.js). The tool draws its own page in its own approved look (graphite and lime, Instrument Sans; Adam's
// decision 4), so there's no hub header or footer.
//
// Stage 2 (S2.8): it mounts once the login is known and hands the tool its hooks: account() ('in' or 'out', kept up
// to date on every render), register (strategy-register, with the publishable key, as the replay register page calls
// replay-register), save (strategy-save, the member's own token), the privacy link (the replay page's) and the
// Scorecard's address. The answers stay in this browser tab (sessionStorage, 24 hours) until the visitor asks for their
// report.
//
// This host only mounts the tool (strategy/app.js) on a div and tears it down when the hub moves to another path.
// core.json and the asset files are bundled by esbuild and handed in, so the tool fetches nothing to start; the
// download copy still reads the fonts and the portrait from /assets/ to build its self-contained file. The saved
// report page (StrategyReport.jsx) uses the same host in saved mode.
import { useEffect, useRef } from 'react'
import { setTitle, SITE } from '../config/site.js'
import { ENV } from '../lib/env.js'
import { callHubFunction } from '../lib/functions.js'
import { mount } from '../strategy/app.js'
import { callStrategyRegister } from '../strategy/calls.js'
import { STRATEGY_TITLE } from '../strategy/route.js'
import core from '../strategy/core.json'
import reportPortrait from '../strategy/assets/adam-slee-report.jpg'
import sidebarPortrait from '../strategy/assets/adam-slee-160.png'
import reportFont from '../strategy/assets/instrument-sans.woff2'
import reportFontRegular from '../strategy/assets/instrument-sans-regular.ttf'
import reportFontBold from '../strategy/assets/instrument-sans-bold.ttf'
import '../strategy/strategy.css'

export const ASSETS = { reportPortrait, sidebarPortrait, reportFont, reportFontRegular, reportFontBold }
export const SCORECARD_URL = 'https://scorecard.adamslee.co.uk'

// The hooks every mount gets; account reads the ref, so a login in another tab is seen at the next result
export function strategyHooks(authRef, extra = {}) {
  return {
    account: () => (authRef.current?.status === 'in' ? 'in' : 'out'),
    register: body => callStrategyRegister(body, { url: ENV.supabaseUrl, key: ENV.publishableKey }),
    save: body => callHubFunction('strategy-save', body),
    privacyUrl: SITE.privacyUrl,
    scorecardUrl: SCORECARD_URL,
    ...extra,
  }
}

export default function PropertyStrategy({ auth }) {
  const ref = useRef(null)
  const authRef = useRef(auth)
  authRef.current = auth
  const known = auth?.status && auth.status !== 'loading'
  useEffect(() => {
    if (!known) return undefined
    setTitle(STRATEGY_TITLE)
    return mount(ref.current, { core, assets: ASSETS, hooks: strategyHooks(authRef) })
  }, [known])
  return <div className="pst" ref={ref} />
}
